import { resolveIdentityPrefixForPath } from '../utils'

export const identityScopeInterceptor = async request => {
  request.originalUrl = resolveIdentityPrefixForPath(request.originalUrl)
}
